export enum AttachmentTypeConfigurationTypeEnum {
    //Активность
    activity = 1,

    //Заявка
    request = 2
}